// VOMARC v4 dark professional theme with segmented working flow and investor track
export const IMG = {
  // Brand logo
  logo:
    "https://customer-assets.emergentagent.com/job_877522a6-c138-4ba3-950c-1baa98676803/artifacts/wnzf7ln0_VOMARC%20LOGO%201.png",
  // Hero blueprint feel
  blueprint:
    "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1800&q=70",
  hero:
    "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1600&q=80",
  // Segmented working tabs
  scan:
    "https://customer-assets.emergentagent.com/job_digital-twin-os-1/artifacts/6g9lqb6n_3d-scanning-a-room-is-a-great-way-to-get-its-exact-3dscanexpertcom-190919_download.avif",
  arApp:
    "https://customer-assets.emergentagent.com/job_digital-twin-os-1/artifacts/kwkxqt2z_895a3009e60a7ccce6df220694126172.webp",
  arRoom:
    "https://images.unsplash.com/photo-1616137466211-f939a420be84?auto=format&fit=crop&w=1400&q=80",
  market:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?auto=format&fit=crop&w=1400&q=80",
  vendor:
    "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1400&q=80",
  workforce:
    "https://images.unsplash.com/photo-1503387837-b154d5074bd2?auto=format&fit=crop&w=1400&q=80",
  warranty:
    "https://images.unsplash.com/photo-1554995207-c18c203602cb?auto=format&fit=crop&w=1400&q=80",
  designer:
    "https://images.unsplash.com/photo-1542621334-a254cf47733d?auto=format&fit=crop&w=1400&q=80",
  scrap:
    "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1400&q=80",
  investor:
    "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1400&q=80",
  spatial:
    "https://images.unsplash.com/photo-1629459322097-a190793bd00b?auto=format&fit=crop&w=1400&q=80",
  electrical:
    "https://images.unsplash.com/photo-1721244654394-36a7bc2da288?auto=format&fit=crop&w=1400&q=80",
};

// What we're building — the modules (no status labels; accurate to stage)
export const modules = [
  { id: "scan", label: "VOMARC Scan", tag: "LiDAR · 96% accuracy", tagColor: "blue", desc: "Phone-camera LiDAR scanning that builds a live 3D plan of your space at 96% accuracy.",
    detail: "Walk the room once with your phone. VOMARC builds a measured 3D mesh with walls, openings, ceiling height and fixed points, then locks it as the base for every design, quote and site check that follows.",
    features: ["Live point cloud → clean 3D mesh in minutes", "Wall, window, door and ceiling dimensions auto-labelled", "Floor-plan upload and guided photo fallback for non-LiDAR phones", "Every later stage references this one verified scan"] },
  { id: "app", label: "AI Design", tag: "AR · live restyle", tagColor: "gold", desc: "Redesign every element in AR, then shop the exact look from a fit-checked marketplace.",
    detail: "Point the phone at the real room and swap paint, flooring, lighting, curtains and furniture live. Every item is fit-checked against the scan so what you see is what actually fits.",
    features: ["Real-time AR paint, panel, light and furniture swaps", "Fit score for every product against your true dimensions", "Save unlimited looks and compare side by side", "Optional in-app designer for premium projects"] },
  { id: "electrical", label: "Electrical Plan", tag: "Safety · no-drill zones", tagColor: "red", desc: "Auto-generate wiring drawings and BOQs, and see no-drill zones before you mount anything.",
    detail: "From the same scan, VOMARC drafts the electrical layout, counts points and cable runs, and marks no-drill zones so TV panels and shelves never hit a conduit.",
    features: ["Auto wiring drawing with switch, socket and light points", "Bill of quantities ready for vendor bids", "No-drill zone overlay in AR before mounting", "Load and circuit summary for the electrician"] },
  { id: "marketplace", label: "Marketplace & Bids", tag: "Vendors · transparent", tagColor: "gold", desc: "Curated products with transparent vendor bidding, compared side by side.",
    detail: "Buy the exact products from the design, then invite verified vendors to bid on the work. Bids arrive against the same scope and dimensions, so comparison is honest.",
    features: ["Paints, panels, lighting, curtains, furniture and decor", "Deliver-only, service execution or vendor-bid checkout", "Side-by-side bids on price, timeline and rating", "Milestone-linked payments held until work is verified"] },
  { id: "fsm", label: "VOMARC FSM", tag: "Execution · milestones", tagColor: "yellow", desc: "Field execution: workforce, materials, milestone payments and AI-checked quality.",
    detail: "The execution engine. Workers check in by GPS and selfie, materials are tracked by batch, each milestone is photo-verified and AI flags deviations from the approved design.",
    features: ["GPS + selfie attendance for every site visit", "Material batch tracking with invoice upload", "Photo-verified milestones release payments", "AI quality check against the approved 3D design"] },
  { id: "passport", label: "VOMARC Passport", tag: "Record · transfers with home", tagColor: "blue", desc: "Your home's complete, verified record: every design, product, warranty, material batch and stage of work. It transfers with your property when you sell.",
    detail: "A permanent, verified history of the home. Scans, designs, invoices, warranties, contractors and material batches, all in one place, and it moves to the next owner with the property.",
    features: ["Every scan, design and invoice archived", "Warranty vault with expiry reminders", "Contractor and material traceability", "Transfers to the new owner on sale"] },
];

export const builtForRoles = ["Homeowners", "Designers & Architects", "Vendors", "Contractors", "Electricians"];
export const designedTagline = "Designed Before Reality.";

export const navItems = [
  { id: "products", label: "Products" },
  { id: "modules", label: "Building" },
  { id: "story", label: "Story", sectionKey: "story" },
  { id: "platform", label: "Platform" },
  { id: "architecture", label: "Architecture" },
  { id: "app", label: "App" },
  { id: "demo", label: "Demo" },
  { id: "investors", label: "Investors" },
];

export const defaultSiteSettings = {
  brand_expansion: "Vision Of Makeover Architecture",
  hero_badge: "AI Design · LiDAR Scan · Marketplace · Vendor Bids · FSM Execution",
  hero_headline: "Design, decide and execute every home transformation, all inside one VOMARC platform.",
  hero_subtext:
    "VOMARC scans your space with phone-camera LiDAR and builds a live 3D spatial plan at 96% dimensional accuracy. Redesign every element in AR. Then turn that design into delivery, vendor bids or full service execution. AI watches every step from start to finish.",
  founder_title: "Built by people who grew up inside renovation.",
  founder_copy:
    "VOMARC is led by Athul S Menon and Bhagyalakshmi Ajith. Both grew up inside the family business, Athira Paints & Renovations, running since 1997. That hands-on background with real homes, real vendors and real deadlines shaped VOMARC into one honest platform for design, products, vendors and execution.",
  tagline_primary: "Nothing hidden , Nothing lost .",
  tagline_secondary: "Design. Transform. Deliver.",
  founder_one_name: "Athul S Menon",
  founder_one_role: "Founder & CEO",
  founder_one_image:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_877522a6-c138-4ba3-950c-1baa98676803/artifacts/dchs2y9f_IMG_0041.jpeg",
  founder_two_name: "Bhagyalakshmi Ajith",
  founder_two_role: "Co-Founder & COO",
  founder_two_image:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_877522a6-c138-4ba3-950c-1baa98676803/artifacts/mn6cdf06_676A7530-7935-434A-A4E8-830E2B9818F3.jpeg",
  founder_one_bio: "Leads vision, product strategy, AI and partnerships.",
  founder_one_linkedin: "",
  founder_two_bio: "Leads operations, product execution and customer experience.",
  founder_two_linkedin: "",
  book_demo_link: "",
  book_demo_embed: "",
  module_status_fsm: "LIVE",
  module_status_scan: "IN DEVELOPMENT",
  module_status_app: "IN DEVELOPMENT",
  module_status_marketplace: "IN DEVELOPMENT",
  module_status_passport: "IN DEVELOPMENT",
  app_demo_link: "",
  vomarc_app_link: "",
  vomarc_fsm_link: "",
  vomarc_app_embed: "",
  vomarc_fsm_embed: "",
  hero_image_url: "",
  founder_image_url:
    "https://customer-assets.emergentagent.com/job_9743d1d0-6053-48e7-8185-60f8ef659ee8/artifacts/8frggdza_IMG_5888.PNG",
  whatsapp_link: "",
  instagram_link: "",
  facebook_link: "",
  google_link: "",
  gmail_link: "",
  linkedin_link: "",
};

// SEGMENTED tabs: the entire "How VOMARC works" is now ONE compact tabbed segment
export const platformSegments = [
  {
    id: "scan",
    label: "Scan",
    title: "Scan and LiDAR with a live 3D spatial plan",
    image: "scan",
    copy:
      "Upload an existing floor plan or use the in-app guided dot-to-dot photo capture. Phone LiDAR plus depth fusion produce a live 3D spatial plan at 96% dimensional accuracy. Not a render. You can rotate, measure and edit it in real time.",
    bullets: ["Guided photo scan", "Phone LiDAR depth", "Floor plan upload", "96% accuracy"],
    stat: { value: "96%", label: "Verified accuracy" },
  },
  {
    id: "design",
    label: "Design",
    title: "AI design and AR customization",
    image: "arRoom",
    copy:
      "Swap paint, texture, sofa, dining table, chairs, curtains, lighting, art, smart additions. Every element renders live in your real room. Want a designer? Request one inside the app.",
    bullets: ["Paint & texture", "Furniture & lighting", "Designer support", "Live AR preview"],
    stat: { value: "200+", label: "Editable elements" },
  },
  {
    id: "market",
    label: "Market",
    title: "Curated product marketplace",
    image: "market",
    copy:
      "Paints, wallpapers, lighting fixtures, curtains, decor, wall panels, furniture, art. Every product is fit-checked to your scan. Add to cart, checkout, receive.",
    bullets: ["Paint • Wallpaper", "Lighting • Curtains", "Furniture • Decor", "Wall art • Smart"],
    stat: { value: "8", label: "Product categories" },
  },
  {
    id: "bids",
    label: "Bids",
    title: "Vendor bid marketplace",
    image: "vendor",
    copy:
      "Painting, tile change, electrical, false ceiling. Share your scanned project. Vendors submit quotations. Compare price, rating and timeline. VOMARC executes the winning bid through FSM.",
    bullets: ["Painting · Tile · Electrical", "False ceiling · Plumbing", "Carpentry · Lighting", "Smart decor install"],
    stat: { value: "12+", label: "Service categories" },
  },
  {
    id: "fsm",
    label: "FSM",
    title: "Field Service Management execution",
    image: "workforce",
    copy:
      "VOMARC FSM coordinates workforce, materials, vendors, milestone payments and live QC. GPS check-in, selfie attendance, live photos and AI-monitored progress. Full customer transparency, from start to finish.",
    bullets: ["GPS workforce", "Material tracking", "Milestone payments", "AI quality control"],
    stat: { value: "100%", label: "Transparent execution" },
  },
  {
    id: "record",
    label: "Record",
    title: "Permanent Home Health Record",
    image: "warranty",
    copy:
      "Every scan, material, contractor, installation date and warranty is stored permanently against your home. That increases resale value, and it makes future maintenance effortless.",
    bullets: ["Warranty vault", "Service history", "Material register", "Contractor logs"],
    stat: { value: "Lifetime", label: "Property record" },
  },
];

// Customization category chips (used in design tab visual)
export const customizationChips = [
  "Paint", "Texture", "Wallpaper", "Sofa", "Dining table",
  "Chairs", "Curtains", "Pendants", "Spot lighting", "Wall art",
  "Rugs", "Smart curtains", "Voice control",
];

// Three checkout options
export const checkoutOptions = [
  { id: "deliver", title: "Deliver only", copy: "Buy products from the marketplace. Receive at doorstep. No service involvement.", icon: "package" },
  { id: "service", title: "Service execution", copy: "VOMARC FSM books verified workers, installs and finishes. Pay by milestone, with full transparency.", icon: "wrench" },
  { id: "full", title: "Full work + vendor bids", copy: "For painting, tile, electrical, false ceiling. Vendors quote, you compare, VOMARC executes.", icon: "gavel" },
];

// Why differentiation
export const whyCards = [
  { id: "fragmented", title: "Renovation is fragmented", copy: "Customers chase moodboards, vendors juggle tasks. VOMARC connects design, commerce and execution in one record." },
  { id: "transparent", title: "Cost transparency", copy: "Every quote, vendor bid, material line item and milestone payment is visible. No hidden mark-ups, ever." },
  { id: "see-first", title: "See before you build", copy: "Live 3D + AR previews at 96% accuracy mean clients sign off only what they truly want." },
  { id: "two-systems", title: "Two platforms, one ecosystem", copy: "VOMARC Main (customer) and VOMARC FSM (execution) share the same room intelligence." },
];

// Investor-only pitch points
export const investorPoints = [
  { id: "market", value: "$680B", label: "Global home renovation market" },
  { id: "fragmented", value: "92%", label: "Fragmented vendor supply" },
  { id: "monetization", value: "5 streams", label: "Commissions, subscriptions, margins, premium AI, SaaS" },
  { id: "stack", value: "PWA + cloud", label: "Firebase auth, Firestore, GCS, AI design" },
];

// Tech stack chips
export const techStack = [
  "Phone LiDAR + Depth Fusion",
  "AI Design Generation",
  "OCR floor plan parsing",
  "Smart cost estimation",
  "Firebase Auth",
  "Firestore real-time DB",
  "Google Cloud Storage",
  "Progressive Web App",
];

// Monetization & future
export const monetization = [
  "Service execution commissions",
  "Vendor subscriptions",
  "Product sales margins",
  "Premium AI design features",
  "Enterprise contractor SaaS",
];

export const futureRoadmap = [
  "AR/VR room visualization",
  "AI cost prediction",
  "Automated contractor matching",
  "Smart material estimation",
  "Nationwide vendor ecosystem",
];

// Working app prototype (kept)
export const featureTabs = [
  { id: "home", label: "Home", title: "Project dashboard", copy: "Active projects, room counts, planned items, budget status and next actions." },
  { id: "flat", label: "Flat", title: "Room-wise planning", copy: "Rooms organised with area, status, budget and design readiness." },
  { id: "ar", label: "AR", title: "Live AR designer", copy: "Wall colour, product pins, before/after, fit checks and budget update as you design." },
  { id: "order", label: "Order", title: "Marketplace + bids", copy: "Products, service packages, vendor bids and milestone payments." },
  { id: "track", label: "Track", title: "FSM tracker", copy: "Stages, GPS workforce, tasks, materials, photos, payments, warranties." },
];

export const appTabs = [
  { id: "home", label: "Home", icon: "⌂" },
  { id: "flat", label: "Flat", icon: "▧" },
  { id: "ar", label: "AR", icon: "◎" },
  { id: "order", label: "Order", icon: "◈" },
  { id: "track", label: "Track", icon: "▤" },
];

export const marketplaceItems = [
  { id: "chair", category: "Furniture", item: "Ivory lounge chair", fit: "98% fit", price: "₹24,500",
    image: "https://images.unsplash.com/photo-1567538096630-e0c55bd6374c?auto=format&fit=crop&w=320&q=70" },
  { id: "paint", category: "Paint", item: "Coral clay wall finish", fit: "92% fit", price: "₹12,800",
    image: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?auto=format&fit=crop&w=320&q=70" },
  { id: "light", category: "Lighting", item: "Warm halo pendant", fit: "95% fit", price: "₹18,000",
    image: "https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?auto=format&fit=crop&w=320&q=70" },
  { id: "curtain", category: "Curtain", item: "Smart beige curtain", fit: "89% fit", price: "₹31,000",
    image: "https://images.unsplash.com/photo-1565183997392-2f6f122e5912?auto=format&fit=crop&w=320&q=70" },
];

export const fsmData = {
  projectId: "VM-2026-0847",
  project: "3BHK Premium Rework",
  status: "Execution",
  budget: "₹1.87L",
  rooms: [
    { name: "Living Room", area: "210 sqft", status: "AR Ready", budget: "₹72K" },
    { name: "Kitchen", area: "96 sqft", status: "Materials", budget: "₹48K" },
    { name: "Bedroom", area: "144 sqft", status: "Designing", budget: "₹39K" },
  ],
  stages: ["Order", "Materials", "Execution", "QC", "Done"],
  worker: "Rajan Pillai",
  vendor: "Kumar Interiors",
  material: "Premium AC-204 emulsion",
  payment: "50% paid • 45% ready",
};

export const operations = [
  { id: "scan", label: "Scan approved", state: "Done" },
  { id: "vendor", label: "Vendor assigned", state: "Pending" },
  { id: "delivery", label: "Material delivery", state: "Pending" },
  { id: "qc", label: "QC approval", state: "Pending" },
];

export const contact = {
  phone: "9544780874",
  email: "vision@vomarc.com",
};
